<div class="flex flex-1 flex-row items-start gap-1">
  <div class="flex flex-col flex-1">
    <div>
      <span class="text-xs text-slate-400">{{
        item.config.text | htmlToText
      }}</span>
    </div>

    <div class="relative">
      <snt-wysiwyg-editor
        [engine]="WysiwygEngine.DEVX"
        [initialContent]="formData.value"
        [placeholder]="''"
        [readOnly]="readOnly"
        [devxEngineMinimal]="true"
        (contentChanged)="onContentChanged()"
        class="border border-slate-200 rounded-md"
      ></snt-wysiwyg-editor>
      <!--span
        class="absolute bottom-2 right-2 text-xs text-slate-400 pointer-events-none"
        >{{ currentTextLength }}/{{ textMaxLength }}</!--span
    --></div>
  </div>

  @if (item.config.quickview) {
    <div class="flex items-center justify-center">
      <i class="fa-light fa-eye opacity-50"></i>
    </div>
  }
</div>
